module.exports = __webpack_public_path__ + "static/media/NEWS_cs21.116e7f54.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/NEWS_cs21.png
// module id = 181
// module chunks = 0